import CSS from 'csstype';

export const modifierInput: CSS.Properties = {
    width: "40%",
};

export const modifierInputContainer: CSS.Properties = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1rem",
};

export const alertBox: CSS.Properties = {
    margin: "1rem 0 1rem 0",
};